"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var react_select_1 = require("react-select");
var styles_1 = require("./styles");
var searchUniversitiesGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query searchUniversities($searchParameters: UniversitySearchParametersInput!) {\n    searchUniversities(searchParameters: $searchParameters) {\n    displayName\n    id\n    name\n  }\n}\n"], ["\n  query searchUniversities($searchParameters: UniversitySearchParametersInput!) {\n    searchUniversities(searchParameters: $searchParameters) {\n    displayName\n    id\n    name\n  }\n}\n"])));
var filterFn = function () { return true; };
/**
 * Connected component. Wraps reac-selects base component with results from
 * api-gateways `searchUniversities` query. Accepts styles that are passed on to the select component
 */
var UniversityAutoComplete = /** @class */ (function (_super) {
    __extends(UniversityAutoComplete, _super);
    function UniversityAutoComplete(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Second order functions takes a refetch function for the
         * `searchUniversitiesQuery`, return a listener that when called
         * 1. updates the current query string
         * 2. Refetches with the updated query sting
         */
        _this.onInputChange = function (inputValue) {
            _this.setState({ queryString: inputValue });
            _this.props.refetch({ searchParameters: { query: inputValue } });
        };
        var queryString = props.defaultValue && props.defaultValue.label || undefined;
        if (props.value) {
            queryString = props.value.label;
        }
        _this.state = { queryString: queryString };
        return _this;
    }
    UniversityAutoComplete.prototype.render = function () {
        var _a = this.props, data = _a.data, allowNull = _a.allowNull, _b = _a.nullOptionLabel, nullOptionLabel = _b === void 0 ? 'Not Applicable' : _b;
        var universities = data === undefined ? [] :
            (data.searchUniversities || []);
        var styles = styles_1.filledStyles(this.props.state);
        var notApplicableOrEmpty = allowNull === true ? [{ label: nullOptionLabel, value: null }] : [];
        var _c = this.state.queryString, queryString = _c === void 0 ? '' : _c;
        var options = __spreadArrays(universities.reduce(function (acc, university) {
            var label = university.displayName || university.name;
            if (label === null) {
                return acc;
            }
            return acc.concat({ label: label, value: university.id });
        }, notApplicableOrEmpty)).sort(function (optionA, optionB) { return optionA.label <= optionB.label ? -1 : 1; });
        return (React.createElement(react_select_1.default, { placeholder: "university", filterOption: filterFn, styles: Object.assign({}, styles, this.props.style), cacheOptions: true, defaultValue: this.props.defaultValue, value: this.props.value, inputValue: queryString, options: options, onInputChange: this.onInputChange, onChange: this.props.onChange }));
    };
    return UniversityAutoComplete;
}(React.Component));
exports.default = (function (props) { return (React.createElement(react_apollo_1.Query, { query: searchUniversitiesGQL, variables: { searchParameters: { query: '' } } }, function (_a) {
    var data = _a.data, refetch = _a.refetch;
    return (React.createElement(UniversityAutoComplete, __assign({ data: data, refetch: refetch }, props)));
})); });
var templateObject_1;
